(function () {
  var selector = ".product-label-container[data-product-code]";
  var apiBaseUrl = "https://admin.e-asakura.net";
  var cacheTtl = 5 * 60 * 1000;
  var staleTtl = 30 * 60 * 1000;
  var labelClass = "en-neume-catch-icon-label";

  var payloadPromise = null;
  var renderScheduled = false;

  function getUtils() {
    return window.ItemManagerThemeUtils || null;
  }

  function normalizeCode(value) {
    return String(value || "").trim();
  }

  function buildUrl() {
    try {
      return new URL("/api/public/en-neume/catch-icons", apiBaseUrl).toString();
    } catch (error) {
      return null;
    }
  }

  function fetchPayload() {
    var url = buildUrl();
    if (!url) return Promise.resolve(null);

    var cacheKey = "item-manager-catch-icons:v2:" + url;
    var utils = getUtils();
    var cached =
      utils && typeof utils.readJsonCache === "function"
        ? utils.readJsonCache({
            key: cacheKey,
            cacheTtl: cacheTtl,
            staleTtl: staleTtl,
          })
        : null;
    if (cached && cached.isFresh) return Promise.resolve(cached.payload);

    if (utils && typeof utils.preconnect === "function") {
      utils.preconnect(apiBaseUrl, "item-manager-catch-icons");
    }

    return fetch(url, {
      credentials: "omit",
      headers: { Accept: "application/json" },
      priority: "low",
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Failed to load catch icons");
        return response.json();
      })
      .then(function (payload) {
        if (utils && typeof utils.writeJsonCache === "function") {
          utils.writeJsonCache({ key: cacheKey, payload: payload });
        }
        return payload;
      })
      .catch(function () {
        return cached ? cached.payload : null;
      });
  }

  function getPayload() {
    if (payloadPromise) return payloadPromise;
    payloadPromise = fetchPayload();
    return payloadPromise;
  }

  function renderIcon(icon) {
    var label = document.createElement("span");
    label.className = "product-label product-label--new-in " + labelClass;

    var text = document.createElement("span");
    text.textContent = String((icon && icon.title) || "").trim();
    // 商品画像が透けて見えるよう背景は半透明。文字色は標準ラベル(グレー)を継承。
    text.style.backgroundColor = "rgba(244, 244, 248, 0.75)";

    label.appendChild(text);
    return label;
  }

  function resolveIcons(container, payload) {
    var productCode = normalizeCode(container.getAttribute("data-product-code"));
    var rules = window.ItemManagerCatchIconRules;

    // 判定は商品ページと共通のファイルに置いている。読み込みに失敗したときは
    // 手動設定ぶんだけを出す（自動表示が出ないだけで、既存の表示は壊れない）。
    if (!rules || typeof rules.resolve !== "function") {
      var productIcons = (payload && payload.productIcons) || {};
      return Array.isArray(productIcons[productCode])
        ? productIcons[productCode]
        : [];
    }

    return rules.resolve({
      payload: payload,
      productCode: productCode,
      minStock: container.getAttribute("data-min-stock"),
      hasPreorder: container.getAttribute("data-preorder") === "true",
    });
  }

  function renderContainers(payload) {
    Array.prototype.forEach.call(
      document.querySelectorAll(selector),
      function (container) {
        var icons = resolveIcons(container, payload);

        Array.prototype.forEach.call(
          container.querySelectorAll("." + labelClass),
          function (existing) {
            existing.remove();
          },
        );

        icons.forEach(function (icon) {
          if (icon && icon.title) container.appendChild(renderIcon(icon));
        });
      },
    );
  }

  function render() {
    if (!document.querySelector(selector)) return;
    getPayload().then(function (payload) {
      if (payload) renderContainers(payload);
    });
  }

  function scheduleRender() {
    if (renderScheduled) return;
    renderScheduled = true;
    window.requestAnimationFrame(function () {
      renderScheduled = false;
      render();
    });
  }

  function boot() {
    render();

    document.addEventListener("shopify:section:load", scheduleRender);

    if ("MutationObserver" in window) {
      new MutationObserver(function (mutations) {
        var relevant = mutations.some(function (mutation) {
          return Array.prototype.some.call(
            mutation.addedNodes,
            function (node) {
              if (node.nodeType !== 1) return false;
              return (
                (node.matches &&
                  node.matches(
                    "product-block, .product-label-container[data-product-code], cc-fetched-content",
                  )) ||
                (node.querySelector && node.querySelector(selector))
              );
            },
          );
        });
        if (relevant) scheduleRender();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
